/* eslint-disable padding-line-between-statements */
import _ from 'lodash';
import { CpCoverablesService } from '../../../capabilities/twia-capability-quoteandbind-cp';
import messages from '../components/TWIABuildingList/TWIABuildingList.messages';
// eslint-disable-next-line import/no-relative-packages
// DE15808
const deleteBuilding = (building, submissionVM, showConfirm, authHeader, setHasBuildingList, 
    setBuildingList, getBuildingsFromLocations, backAction, updateWizardData,index) => {
    const sessionID = submissionVM.sessionUUID.value;
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
    const locationsValue = submissionVM.lobData.commercialProperty.coverables.locations.value;
    const locationIndex = _.findIndex(locationsValue, (loc) => loc.publicID === building.locationId);
    showConfirm({
        title: messages.wantToDeleteBuilding,
        message: messages.deleteMessage,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: messages.yesModal,
        cancelButtonText: messages.closeModal,
    }).then((results) => {
        if (results === 'cancel' || results === 'close') {
            return
        }

        const loc = locationsValue.find(lo => lo.publicID === building.locationId);
        let promise;
        const removeLocation = loc.buildings.length === 1 && !loc.isPrimary;
        // DE19023
        const buildingIndex = _.findIndex(loc.buildings, (bldg) => bldg.publicID 
        === building.publicID);
       
        // DE18640 setting construction_TWIA to undefined for the deleted building only
        // DE18701
        if(buildingIndex){
            _.set(submissionVM, 
                `lobData.commercialProperty.coverables.locations.value[${locationIndex}].buildings[${buildingIndex}].construction_TWIA`, undefined)
        }
        
        if (removeLocation) {
            promise = CpCoverablesService.removeCPLocation(jobID, loc.publicID, sessionID, authHeader);
        } else {
            promise = CpCoverablesService.removeCPBuilding(jobID, loc.publicID, building.publicID, sessionID, authHeader);
        }

        handleDeleteBuildingState(promise, building.publicID, removeLocation, loc, 
            locationsValue, setHasBuildingList, setBuildingList, getBuildingsFromLocations, 
            backAction, updateWizardData, submissionVM);

    })

};

const handleDeleteBuildingState = (deletePromise, buildingID, removeLocation, location,
     locations, setHasBuildingList, setBuildingList, getBuildingsFromLocations, 
     backAction, updateWizardData, submissionVM) => {
    deletePromise
        .then(() => {
            if (removeLocation) {
                _.remove(locations, currLocation => currLocation.publicID === location.publicID);
            }
            
            removeBuilding(buildingID, location, locations);
            updateWizardData(submissionVM)
        }).then(() => {
            backAction()
            setBuildingList(getBuildingsFromLocations(locations))
            if (locations.every(loc => loc.buildings.length === 0)) {
                setHasBuildingList(false);
            }
        })

}

const removeBuilding = (buildingID, location, buildingList) => {
    _.remove(location.buildings, building => building.publicID === buildingID);
    _.remove(buildingList, building => building.publicID === buildingID);
}

export default {
    'deleteBuilding': deleteBuilding
}